import Vue from 'vue'
import Vuex from 'vuex'

import tasks from './modules/tasks'
import filters from './modules/filters'
import types from "./modules/types";
import banners from "./modules/banners";
import history from "./modules/history";

Vue.use(Vuex)

export default new Vuex.Store({
  
  modules: { tasks, filters, types, banners, history }
})
